import { useAuth0 } from "@auth0/auth0-react";

export const useLogout = () => {
  const { logout } = useAuth0();

  return { logout: () => logout({ returnTo: import.meta.env.VITE_HOST_DEV }) };
};
